/**
 * 富文本编辑器纯逻辑工具（纯函数，与小程序端 richTextEditor/richTextUtils.js 保持一致）
 * 编辑器空内容归一化、旧纯文本数据兼容
 */

// 去除全部 HTML 标签后的可见文本（&nbsp; 视为空格）
function visibleText(html) {
  return String(html || "")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/gi, " ")
    .trim();
}

/**
 * 空值归一化：''、'<p><br></p>'、纯空白标签串 → ''；有可见内容原样返回
 * @param {string} html
 * @returns {string}
 */
export function normalizeHtml(html) {
  if (!html) return "";
  return visibleText(html) ? String(html) : "";
}

/**
 * 是否含 HTML 标签
 * @param {string} str
 * @returns {boolean}
 */
export function isRichHtml(str) {
  return /<[a-zA-Z][^>]*>/.test(String(str || ""));
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

/**
 * 旧纯文本转可用 HTML：先转义 & < >（防注入），再 \n → <br>
 * @param {string} str
 * @returns {string}
 */
export function plainTextToHtml(str) {
  return escapeHtml(String(str || "")).replace(/\n/g, "<br>");
}
